"use strict";

($dt => {

	const controller = {

		Init: () => {

			const notificationBarElem = document.getElementById('notification-bar');

			if (notificationBarElem) {

				// Request Options
				const request_options = {
					method: 'POST',
					credentials: 'same-origin',
					redirect: 'error',
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded',
					},
					body: 'post_id=' + $dt.Util.getPostID()
				};

				// Request Object
				const request = new Request($dt.ajax_url + '?action=discoverycube_check_notification_bar', request_options);

				// Fetch
				fetch(request).then(response => {
					if (response.status === 200) {
						return response.json();
					} else {
						return;
					}
				}).then(json => {
					if (json && json.status === 'live') {
						document.body.classList.add('notification-bar-active');
						notificationBarElem.innerHTML = json.text_content;
						notificationBarElem.classList.add('for-location-' + json.css_class);
						notificationBarElem.classList.add('notification-display');
					}
				});
			}

		}

	};

	if ($dt.notification_bar) {
		$dt.autostart.push(() => {
			controller.Init();
		});
	}

})(window.d3_wp_themejs);
